import React from 'react'

const Preview = () => {
  return (
    <div>
      <h1>Welcome to Preview page </h1>
    </div>
  )
}

export default Preview